(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charmacitta-header"]) return;
  try {
    
function closeCharmacittaMenus(event) {
  document.querySelectorAll('.charm-mobile-menu[open]').forEach(menu => {
    if (event.type === 'pageshow' || event.type === 'popstate' || event.type === 'hashchange' || event.key === 'Escape' || (event.type === 'click' && (!menu.contains(event.target) || event.target.closest('a')))) {
      menu.open = false;
      if (event.key === 'Escape') menu.querySelector('summary').focus();
    }
  });
}
document.addEventListener('click', closeCharmacittaMenus);
document.addEventListener('keydown', closeCharmacittaMenus);
window.addEventListener('pageshow', closeCharmacittaMenus);
window.addEventListener('popstate', closeCharmacittaMenus);
window.addEventListener('hashchange', closeCharmacittaMenus);
window.addEventListener('pageshow', event => {
  if (event.persisted && document.querySelector('main[data-template="cart"]')) {
    sessionStorage.removeItem('cart-count');
    window.location.reload();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
